<template>
  <!-- 车辆登记 -->
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="80px" size="mini">
        <div class=" formItemBox">
          <el-form-item label="车牌号:" prop="vhcRegistCode">
            <el-input  placeholder="" v-model="searchFrom.vhcRegistCode"></el-input>
          </el-form-item>
          <el-form-item label="排放阶段:" prop="standardsId">
            <el-select placeholder="请选择" v-model="searchFrom.standardsId">
              <el-option
                v-for="item in pfbz"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="机械环保代码:" prop="vhcMachineCode">
            <el-input  placeholder="" v-model="searchFrom.vhcMachineCode"></el-input>
          </el-form-item> -->
          <el-form-item label="上报状态 :" prop="reportStatus">
              <el-select v-model="searchFrom.reportStatus" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="待上报" value="0" ></el-option>
                <el-option  label="上报中" value="1" ></el-option>
                <el-option  label="已上报" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上报时间:" prop="reportTime">
              <el-date-picker
                v-model="searchFrom.reportTimeArr "
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
           <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker
                v-model="searchFrom.createTimeArr"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="00BP007B001"  >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" btnCode="00BP007B001"  @click="addVeicle">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent"
                @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
               <el-button type="text" size="mini"  btnCode="00BP007B001"    @click="modifyVeicle(scope.row)">修改</el-button>
             <el-button type="text" size="mini"  btnCode="00BP007B001" v-if="scope.row.reportStatus!=2"  @click="delFN(scope.row)">删除</el-button>
             <el-button type="text" size="mini"  btnCode="00BP007B001"  @click="detailFN(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="reportStatus" label="上报状态">
          <template scope="scope">
            <div>
              <span>{{["待上报", "上报中", "已上报"][scope.row.reportStatus]}}</span>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="reportTime" width="160" :formatter="dateFormat" label="上报时间"></el-table-column>
         <el-table-column property="reportDescribe" min-width="170"  :show-overflow-tooltip="true" label="上报描述"></el-table-column>
        <el-table-column prop="vhcRegistCode"  min-width="220" :show-overflow-tooltip="true" label="车牌号"></el-table-column>
         <el-table-column prop="registDate" width="160" :formatter="dateFormat1" label="注册日期"></el-table-column>
        <el-table-column prop="standardsName"  min-width="160"  :show-overflow-tooltip="true" label="排放阶段"></el-table-column>
        <el-table-column prop="vhcVinCode"   width="170"  :show-overflow-tooltip="true" label="车辆识别代码"></el-table-column>
        <el-table-column prop="vhcEngineCode" width="100"  :show-overflow-tooltip="true" label="发动机号码"></el-table-column>
         <el-table-column property="energyType" label="燃料种类" width="80" >
          <template scope="scope">
            <span v-if="scope.row.energyType!==null">{{["其他","******", "汽油","柴油", "天然气", "电"  ][scope.row.energyType+1]}}</span>
          </template>
          </el-table-column>
        <el-table-column property="isObd"  width="120" label="是否安装OBD" >
          <template scope="scope">
            {{[ "是", "否" ][scope.row.isObd-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="obdSetupDate" width="170" :formatter="dateFormat1"  label="OBD安装日期"></el-table-column>
        <el-table-column prop="createUserName" width="170"   label="创建者"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[25,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1100px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="160px" size="mini">
        <div class="inpBox">
               <el-form-item label="车牌号:" prop="vhcRegistCode" >
                <el-input  placeholder="" v-model="addFrom.vhcRegistCode"  maxlength="20"></el-input>
              </el-form-item>
               <el-form-item label="注册日期:" prop="registDate">
                <el-date-picker
                  v-model="addFrom.registDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="排放阶段:"  prop="standards">
                <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standards">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆识别代码:" prop="vhcVinCode" >
                <el-input  placeholder="" v-model="addFrom.vhcVinCode"  maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="发动机号码:" prop="vhcEngineCode" >
                <el-input  placeholder="" v-model="addFrom.vhcEngineCode"  maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="燃料种类:"  prop="energyType">
                <el-select placeholder="请选择" v-model="addFrom.energyType">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="是否安装OBD:"  prop="isObd">
                <el-select placeholder="请选择"  v-model="addFrom.isObd">
                  <el-option label="是"  :value=1></el-option>
                  <el-option label="否"  :value=2 ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="OBD安装日期:" prop="obdSetupDate" v-if="addFrom.isObd==1">
                <el-date-picker
                  v-model="addFrom.obdSetupDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
           </div>
           <div class="box" v-if="dialogVisible">
                <div class="imgBox" >
                    <uploadImgs :imgList.sync='imgSCQD'   ></uploadImgs>
                    <h6>随车清单照片</h6>
                </div>
                <div class="imgBox" >
                    <uploadImgs :imgList.sync='imgXSZ'   ></uploadImgs>
                    <h6>行驶证照片</h6>
                </div>
            </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="detailMsrk" @close="closeDialog" width="1100px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="160px" size="mini">
        <div class="inpBox">
              <el-form-item label="车牌号:" prop="vhcRegistCode" >
                 <div style="width:170px">{{addFrom.vhcRegistCode}}</div>
              </el-form-item>
              <el-form-item label="注册日期:" prop="registDate">
                 <div style="width:170px">{{addFrom.registDate|dateFormat1}}</div>
              </el-form-item>
              <el-form-item label="排放阶段:"  prop="standards">
               <div style="width:170px">{{addFrom.standardsName}}</div>
             </el-form-item>
               <el-form-item label="车辆识别代码:" prop="vhcMachineCode" >
                <div style="width:170px">{{addFrom.vhcVinCode}}</div>
              </el-form-item>
               <el-form-item label="发动机号码:" prop="vhcMachineCode" >
                <div style="width:170px">{{addFrom.vhcEngineCode}}</div>
              </el-form-item>
              <el-form-item label="燃料种类:" prop="vhcMachineCode" >
                 <div  style="width:170px" v-if="addFrom.energyType!==null">{{["其他","******", "汽油","柴油", "天然气", "电"  ][addFrom.energyType+1]}}</div>
              </el-form-item>
               <el-form-item label="是否安装OBD:" prop="isObd" >
                 <div v-if="addFrom.isObd"> {{[ "是", "否" ][addFrom.isObd-1]}}</div>
                 <div v-else> -</div>
              </el-form-item>
               <el-form-item label="OBD安装日期:" prop="obdSetupDate">
                 <div style="width:170px">{{addFrom.obdSetupDate|dateFormat1}}</div>
              </el-form-item>
              <div class="box"  v-if="detailMsrk">
                <div class="imgBox" >
                     <el-image :src="addFrom.vhcBoardAccessUrl"  :preview-src-list="getSrcList(0)"></el-image>
                    <h6>随车清单照片</h6>
                </div>
                 <div class="imgBox" >
                     <el-image :src="addFrom.vhcLicenseAccessUrl" :preview-src-list="getSrcList(1)"></el-image>
                    <h6>行驶证照片</h6>
                </div>
              </div>
           </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailMsrk = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { compressImages } from '@/utils/compressImages'
import { insideinfoList, insideinfoAdd, insideinfoUpdate, insideinfoDelete, cVElist } from '@/api/vgs-driver'
import uploadImgs from '@/components/uploadImgs.vue'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  components: {
    uploadImgs
  },
  data () {
    return {
      isDisable: false,
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {
      },
      isAdd: false,
      title: '添加',
      pfbz: [],
      NYtype: [
        { value: '', label: '请选择' },
        { value: 0, label: '******' },
        { value: -1, label: '其他' },
        { value: 1, label: '汽油' },
        { value: 2, label: '柴油' },
        { value: 3, label: '天然气' },
        { value: 4, label: '电' }
      ],
      rules: {
        vhcRegistCode: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
          // this.rule.vhcNo
        ],
        registDate: [
          { required: true, message: '请选择注册', trigger: 'blur' }
        ],
        standards: [
          { required: true, message: '请选择排放阶段', trigger: 'blur' }
        ],
        vhcVinCode: [
          { required: true, message: '请输入车辆识别代码', trigger: 'blur' }
        ],
        vhcEngineCode: [
          { required: true, message: '请输入发动机号码', trigger: 'blur' }
        ],
        vhcMachineCode: [
          { required: true, message: '请输入机械环保代码', trigger: 'blur' }
        ]

      },
      dialogVisible: false,
      imgfile: new FormData(),
      imgSCQD: [],
      imgXSZ: [],
      detailMsrk: false
      // btnFlg: [],
      // btnIdArr: [ '00BP007B001', '00BP007B002',
      //   '00BP007B003', '00BP007B004', '00BP007B005', '00BP007B006']
    }
  },
  created () {
    // this.btnFlg = getBtn(this.btnIdArr, '/vehicleRegister')
    this.getList(this.searchFrom)
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.driverName + '/vehicle/insideinfo/exportList',
        form,
        '场内车辆管理列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击凭证放大
    getSrcList (index) {
      let arr = [this.addFrom.vhcBoardAccessUrl, this.addFrom.vhcLicenseAccessUrl]
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 详情
    detailFN (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.detailMsrk = true
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      insideinfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addVeicle () {
      this.title = '添加'
      this.dialogVisible = true
      this.isAdd = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 修改
    modifyVeicle (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      if (row.vhcBoardAccessUrl != '') {
        this.$set(this.imgSCQD, 0, { status: 'ready', url: row.vhcBoardAccessUrl, flag: true })
      }
      if (row.vhcLicenseAccessUrl != '') {
        this.$set(this.imgXSZ, 0, { status: 'ready', url: row.vhcLicenseAccessUrl, flag: true })
      }
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFrom.standards) {
            if (this.addFrom.standards.id == '') {
              this.addFrom.standardsName = null
            } else {
              this.addFrom.standardsName = this.addFrom.standards.name
            }
            this.addFrom.standardsId = this.addFrom.standards.id
          }
          this.imgfile.set('params', JSON.stringify(this.addFrom))
          let that = this
          let imgList = []
          if (this.imgSCQD.length == 0) {
            this.$alert('请上传随车清单', '系统提示')
            return
          } else if (this.imgSCQD[0].flag) {
            imgList.push(null)
          } else {
            imgList.push(this.imgSCQD[0])
          }
          if (this.imgXSZ.length == 0) {
            this.$alert('请上传驾驶证', '系统提示')
            return
          } else if (this.imgXSZ[0].flag) {
            imgList.push(null)
          } else {
            imgList.push(this.imgXSZ[0])
          }
          compressImages(imgList, {
            width: 1000
          }).then(result => {
            if (result[0]) {
              that.imgfile.set('vhcBoardFile', result[0])
            }
            if (result[1]) {
              that.imgfile.set('vhcLicenseFile', result[1])
            }
            this.save1()
          })
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        insideinfoAdd(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        insideinfoUpdate(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 删除
    delFN  (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        insideinfoDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },

    closeDialog () {
      this.addFrom = {
      }
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      this.imgSCQD = []
      this.imgXSZ = []
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        registerDates: null
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      if (cellValue) {
        var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
        var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
        var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
        return (
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
        )
      }

      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      let str = ''
      if (cellValue) {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
  .searchBtnBox {
    margin-left: 10px;
  }
  .inpBox .el-date-editor{
    width: 350px!important;
  }
  .imgBox{
    display: flex;
    .item{
      display: flex;
      width: 50%;
      justify-content: space-around;
    }
  }
  .jiaoyan /deep/.el-date-editor {
    width: 150px!important;
  }
  /deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
  }
  .box{
    display: flex;
    justify-content: space-around;
    .imgBox{
      display: flex;
      flex-direction: column;
      width: 386px;
      height: 290px;
      /deep/.el-upload--picture-card{
        width: 386px;
        height: 240px;
      }
    }
    h6{
      text-align: center;
    }
    /deep/.el-upload--picture-card {
      background-image: url(../../../assets/images/upload1.png);
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item{
      width: 386px;
      height: 240px;
    }
  }
  .loogImgBox{
    display: flex;
    justify-content: space-around;
    .box1{
      width: 48%;
    }
    img{
      width: 100%;
    }
  }

  /deep/.inpBox .bigInp .el-input__inner{
    width: 250px;
  }
  .hidden /deep/.el-upload--picture-card{
      display: none;
    }
</style>
